import * as React from "react";
/**
 * This icon from MDL2 is not available in @fluentui/react-icons
 * So we have to create the react icon component ourselves
 */ export const NoTasksDark = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "188",
        height: "188",
        viewBox: "0 0 188 188",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "transparent"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint0_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint1_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint2_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint3_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint4_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint5_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint6_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint7_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint8_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint9_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint10_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint11_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint12_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint13_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint14_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint15_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint16_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint17_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M57.5629 96.58C57.4178 96.7528 57.2588 96.9273 57.0929 97.0898C53.8927 100.292 48.7019 100.292 45.5017 97.0898L30.5513 82.1359C27.3511 78.9357 27.3511 73.7484 30.5513 70.5464C33.7515 67.3462 38.9354 67.3462 42.1356 70.5464L48.8563 77.2671C49.6364 78.0472 50.9323 77.9311 51.5612 77.0247L69.4444 51.2537C70.6748 49.4808 72.4788 48.3438 74.4279 47.9187C76.5706 47.4521 78.8999 47.8427 80.849 49.1922C84.5676 51.7721 85.4869 56.8765 82.9088 60.5951L59.0974 94.9143C58.655 95.5536 58.1366 96.11 57.5629 96.58Z",
        fill: "url(#paint18_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint19_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint20_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint21_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint22_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint23_radial_278_19061)",
        fillOpacity: "0.6"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "72.7031",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint24_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "56.2612",
        cy: "129.79",
        rx: "15.2383",
        ry: "15.2383",
        fill: "#262626"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "56.2612",
        cy: "129.79",
        rx: "15.2383",
        ry: "15.2383",
        fill: "url(#paint25_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "56.2612",
        cy: "129.79",
        rx: "15.2383",
        ry: "15.2383",
        fill: "url(#paint26_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "119.142",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint27_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "119.142",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint28_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "119.142",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint29_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "119.142",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint30_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("rect", {
        x: "80.9503",
        y: "119.142",
        width: "78.9453",
        height: "21.2969",
        rx: "10.6484",
        fill: "url(#paint31_radial_278_19061)",
        fillOpacity: "0.6"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "92.6004",
        cy: "129.79",
        rx: "8.8125",
        ry: "8.8125",
        transform: "rotate(-5.82907 92.6004 129.79)",
        fill: "url(#paint32_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "92.6004",
        cy: "129.79",
        rx: "8.8125",
        ry: "8.8125",
        transform: "rotate(-5.82907 92.6004 129.79)",
        fill: "url(#paint33_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "92.6004",
        cy: "129.79",
        rx: "8.8125",
        ry: "8.8125",
        transform: "rotate(-5.82907 92.6004 129.79)",
        fill: "url(#paint34_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("ellipse", {
        cx: "92.6004",
        cy: "129.79",
        rx: "8.8125",
        ry: "8.8125",
        transform: "rotate(-5.82907 92.6004 129.79)",
        fill: "url(#paint35_radial_278_19061)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "147.767",
        cy: "83.2728",
        r: "8.8125",
        transform: "rotate(-5.82907 147.767 83.2728)",
        fill: "url(#paint36_linear_278_19061)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "147.767",
        cy: "83.2728",
        r: "8.8125",
        transform: "rotate(-5.82907 147.767 83.2728)",
        fill: "url(#paint37_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "147.767",
        cy: "83.2728",
        r: "8.8125",
        transform: "rotate(-5.82907 147.767 83.2728)",
        fill: "url(#paint38_radial_278_19061)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "147.767",
        cy: "83.2728",
        r: "8.8125",
        transform: "rotate(-5.82907 147.767 83.2728)",
        fill: "url(#paint39_radial_278_19061)",
        fillOpacity: "0.7"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M134.376 77.1094C134.376 77.7178 133.883 78.2109 133.275 78.2109C132.666 78.2109 132.173 77.7178 132.173 77.1094C132.173 76.501 132.666 76.0078 133.275 76.0078C133.883 76.0078 134.376 76.501 134.376 77.1094Z",
        fill: "#EB4824"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M115.65 82.6172C115.65 83.2256 115.156 83.7188 114.548 83.7188C113.94 83.7188 113.446 83.2256 113.446 82.6172C113.446 82.0088 113.94 81.5156 114.548 81.5156C115.156 81.5156 115.65 82.0088 115.65 82.6172Z",
        fill: "#EB4824"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M107.021 88.4922C107.325 88.4922 107.571 88.2456 107.571 87.9414C107.571 87.6372 107.325 87.3906 107.021 87.3906C106.716 87.3906 106.47 87.6372 106.47 87.9414C106.47 88.2456 106.716 88.4922 107.021 88.4922Z",
        fill: "#EB4824"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M127.032 76.9258C127.032 77.23 126.786 77.4766 126.482 77.4766C126.177 77.4766 125.931 77.23 125.931 76.9258C125.931 76.6216 126.177 76.375 126.482 76.375C126.786 76.375 127.032 76.6216 127.032 76.9258Z",
        fill: "#EB4824"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M123.544 90.6953C123.848 90.6953 124.095 90.4487 124.095 90.1445C124.095 89.8403 123.848 89.5938 123.544 89.5938C123.24 89.5938 122.993 89.8403 122.993 90.1445C122.993 90.4487 123.24 90.6953 123.544 90.6953Z",
        fill: "#EB4824"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(58.9336 133.84) rotate(-111.501) scale(19.5353 20.1306)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.510864",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint1_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(54.1602 124.477) rotate(60.8901) scale(18.492 20.2598)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.550813",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint2_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(67.5625 81.8828) rotate(-54.4836) scale(57.5176 18.6062)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.205455",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.744692",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint3_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(147.059 87.7578) rotate(-1.39234) scale(52.8906 34.371)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.174774",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.361538",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint4_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(119.703 94) scale(71.2344 12.4617)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0257732",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.863092",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint5_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(151.281 133.656) rotate(-1.68468) scale(31.2244 24.07)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.211878",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.541393",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint6_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(119.703 140.266) rotate(-0.407798) scale(103.182 17.0764)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00728169",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.541393",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint7_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(121.172 119.152) rotate(-0.465816) scale(67.7483 13.8665)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00187881",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.935228",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint8_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(118.602 73.0703) rotate(-0.154023) scale(68.2971 17.2953)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00818012",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.822589",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint9_linear_278_19061",
        x1: "34.0455",
        y1: "67.1787",
        x2: "50.7536",
        y2: "102.124",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.208361",
        stopColor: "#58AAFE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#2764E7"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint10_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(69.8463 85.1709) rotate(-145.424) scale(16.4993 177.659)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.216757",
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.545886",
        stopColor: "#59A9FE",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint11_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(37.7174 92.6982) rotate(-44.326) scale(11.0355 118.826)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.216757",
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.739275",
        stopColor: "#4289F3",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint12_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(42.7662 71.4014) rotate(136.848) scale(8.05305 23.435)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.739275",
        stopColor: "#509CF9",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint13_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(60.3912 64.6084) rotate(34.0193) scale(8.86019 38.867)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.544786",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint14_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(49.8346 74.9814) rotate(9.98496) scale(13.2356 14.2158)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.498391",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint15_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(51.7735 100.977) rotate(-94.1882) scale(16.4924 35.2815)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.341604",
        stopColor: "#9DEAFF",
        stopOpacity: "0.245477"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.585709",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint16_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(25.8867 75.549) rotate(-10.2075) scale(29.008 62.0553)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.219062",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint17_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(35.4225 67.1787) rotate(80.0371) scale(30.3078 116.807)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.209976",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint18_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(79.9551 47.1837) rotate(100.935) scale(76.9458 200.295)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9DEAFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.129301",
        stopColor: "#9DEAFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint19_linear_278_19061",
        x1: "92.8984",
        y1: "67.0117",
        x2: "95.2438",
        y2: "91.936",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.447003",
        stopColor: "#8B52F4"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.982516",
        stopColor: "#F462AB"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint20_linear_278_19061",
        x1: "120.423",
        y1: "72.7031",
        x2: "120.423",
        y2: "94",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.086207",
        stopColor: "#5B2AB5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.258621",
        stopColor: "#8B52F4",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.767241",
        stopColor: "#F462AB",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.922414",
        stopColor: "#FDAFD9"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint21_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(113.163 78.2025) rotate(-173.428) scale(48.0501 23.6078)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.921443",
        stopColor: "#F4A7F7",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.964509",
        stopColor: "#F4A7F7"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint22_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(137.03 90.8705) rotate(-172.782) scale(59.8444 22.5733)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.885767",
        stopColor: "#5B2AB5",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.963592",
        stopColor: "#5B2AB5"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint23_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(150.73 86.2891) rotate(42.7688) scale(10.0038 11.6044)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.622051",
        stopColor: "#B91D6B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.891436",
        stopColor: "#F97DBD",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint24_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(86.3809 95.5605) rotate(-150.218) scale(17.5572 5.81745)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.501284",
        stopColor: "#F4A7F7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.921443",
        stopColor: "#F4A7F7",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint25_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(45.513 118.583) rotate(47.2165) scale(31.6613 24.4482)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.746963",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.92725",
        stopColor: "#595959"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint26_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(58.9154 133.637) rotate(56.6336) scale(18.0259 18.0259)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.630268",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.929646",
        stopColor: "#0E0E0E"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint27_linear_278_19061",
        x1: "144.925",
        y1: "140.439",
        x2: "137.398",
        y2: "119.142",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00286554",
        stopColor: "#36DFF1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.851309",
        stopColor: "#88E06C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint28_linear_278_19061",
        x1: "120.423",
        y1: "119.142",
        x2: "120.423",
        y2: "140.439",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0858112",
        stopColor: "#4CA942"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.258225",
        stopColor: "#82DF79",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.715122",
        stopColor: "#50D7D4",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.982363",
        stopColor: "#B9F0FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint29_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(113.163 124.641) rotate(-173.428) scale(48.0501 23.6078)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.892068",
        stopColor: "#B9F0FF",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.981339",
        stopColor: "#B9F0FF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint30_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(137.03 137.309) rotate(-173.991) scale(59.6284 22.4918)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.863981",
        stopColor: "#4CA942",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.95133",
        stopColor: "#4CA942"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint31_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(95.8135 132.582) rotate(32.4532) scale(11.205 11.3094)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.622051",
        stopColor: "#4CA943"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#86E071",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint32_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(15.9863 16.9495 -22.1465 17.5707 91.077 125.954)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.147159",
        stopColor: "#63686E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.347159",
        stopColor: "#383B3D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.614405",
        stopColor: "#2C2F30"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint33_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(91.8706 128.629) rotate(-105.751) scale(12.8243 12.7309)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.578741",
        stopColor: "#383B3D",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.799343",
        stopColor: "#70777D"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint34_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(93.875 131.267) rotate(-118.361) scale(13.5468 12.7733)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.637918",
        stopColor: "#63686E",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.812745",
        stopColor: "#889096"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint35_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(90.7202 125.515) rotate(76.9248) scale(8.31111 11.6906)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.00261699",
        stopColor: "#B9C0C7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.517495",
        stopColor: "#63686E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint36_linear_278_19061",
        x1: "138.329",
        y1: "75.5064",
        x2: "160.28",
        y2: "98.2669",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.176446",
        stopColor: "#FF921F"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.592845",
        stopColor: "#FB5937"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.981428",
        stopColor: "#CA2134"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint37_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(147.038 82.1119) rotate(-105.751) scale(12.8243 12.7309)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.567991",
        stopColor: "#FF921F",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.763668",
        stopColor: "#FFD394"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint38_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(149.042 84.7492) rotate(-118.361) scale(13.5468 12.7733)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.603892",
        stopColor: "#FF921F",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.753518",
        stopColor: "#FFD394"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint39_radial_278_19061",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(145.887 78.9978) rotate(76.9248) scale(8.31111 11.6906)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.162497",
        stopColor: "#FFD394"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FF921F",
        stopOpacity: "0"
    }))));
